module.exports = __webpack_public_path__ + "static/img/title_07.5e5470f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/question/title_07.png
// module id = 6mIv
// module chunks = 1